export default function ($timeout) {

  return {
    restrict: 'A',

    link: function($scope, $element, $attrs) {
      $element.bind('touchstart', function() {
        $scope.longPress = true;
        $timeout(function() {
          if ($scope.longPress) {
            $scope.$apply(function() {
              $scope.$eval($attrs.onLongPress);
            });
          }
        }, 600);
      });

      $element.bind('touchend', function() {
        $scope.longPress = false;
        if ($attrs.onTouchEnd) {
          $scope.$apply(function() {
            $scope.$eval($attrs.onTouchEnd);
          });          
        }
      });
    }
  };
}



// WEBPACK FOOTER //
// ./client/app/common/directives/onLongPress.js